import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`// Call posthog.group() to create a group before capturing events.
// It sends a \`$groupidentify\` event to create or update the group.
// It will also create the group type if it doesn't exist. In the
// web SDK, it also associates all subsequent events in the session
// with the group.
posthog.group('company', 'company_id_in_your_db');
// This event will be associated with the company above.
posthog.capture('user_signed_up');

// If the group type is already created, you can also manually add
// the \`$groups\` property to any event you want to associate with
// the group.
posthog.capture('user_signed_up', {
    '$groups': {
        'company': 'company_id_in_your_db'
    }
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`# Call posthog.group_identify() to create a group before capturing events.
# It sends a \`$groupidentify\` event to create or update the group.
# It will also create the group type if it doesn't exist.
posthog.group_identify('company', 'company_id_in_your_db')

# Once the group is created, you can associate events with it by
# passing the \`group\` argument. The \`group\` argument is required
# for every event that should be associated with the group.
posthog.capture(
    'user_signed_up',
    groups={'company': 'company_id_in_your_db'}
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`// Call posthog.GroupIdentify{} to create a group before capturing events.
// It sends a \`$groupidentify\` event to create or update the group.
// It will also create the group type if it doesn't exist.
client.Enqueue(posthog.GroupIdentify{
    Type: "company",
    Key:  "company_id_in_your_db",
})

// Once the group is created, you can associate events with it by
// passing the \`$groups\` property. The \`$groups\` property is required
// for every event that should be associated with the group.
client.Enqueue(posthog.Capture{
    DistinctId: "user_distinct_id",
    Event: "user_signed_up",
    Groups: posthog.NewGroups().
        Set("company", "company_id_in_your_db"),
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`// Call posthog.groupIdentify() to create a group before
// capturing events. It sends a \`$groupidentify\` event to create
// or update the group. It will also create the group type if it
// doesn't exist.
posthog.groupIdentify('company', 'company_id_in_your_db')

// Once the group is created, you can associate events with it by
// passing the \`groups\` property. The \`groups\` property is required
// for every event that should be associated with the group.
posthog.capture({
    event: 'user_signed_up',
    distinctId: 'user_distinct_id',
    groups: { company: 'company_id_in_your_db' }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`// Call PostHog::groupIdentify() to create a group before capturing events.
// It sends a \`$groupidentify\` event to create or update the group.
// It will also create the group type if it doesn't exist.
PostHog::groupIdentify(array(
    'groupType' => 'company',
    'groupKey' => 'company_id_in_your_db'
));

// Once the group is created, you can associate events with it by
// passing the \`$groups\` property. The \`$groups\` property is required
// for every event that should be associated with the group.
PostHog::capture(array(
    'distinctId' => 'user_distinct_id',
    'event' => 'user_signed_up',
    '$groups' => array("company" => "company_id_in_your_db")
));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ios_swift"
        }}>{`// Call PostHogSDK.shared.group() to create a group before capturing events.
// It sends a \`$groupidentify\` event to create or update the group.
// It will also create the group type if it doesn't exist. In the
// iOS SDK, it also associates all subsequent events in the
// session with the group.
PostHogSDK.shared.group(type: "company", key: "company_id_in_your_db")
// This event will be associated with the company above.
PostHogSDK.shared.capture("user_signed_up")

// If the group type is already created, you can also manually add
// the \`$groups\` property to any event you want to associate with
// the group.
PostHogSDK.shared.capture(
    event: "user_signed_up",
    properties: [
        "$groups": [
            "company": "company_id_in_your_db"
        ]
    ]
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-android_kotlin"
        }}>{`// Call PostHog.group() to create a group before capturing events.
// It sends a \`$groupidentify\` event to create or update the group.
// It will also create the group type if it doesn't exist. In the
// Android SDK, it also associates all subsequent events in the
// session with the group.
PostHog.group(type = "company", key = "company_id_in_your_db")
// This event will be associated with the company above.
PostHog.capture("user_signed_up")

// If the group type is already created, you can also manually add
// the \`$groups\` property to any event you want to associate with
// the group.
PostHog.capture(
    event = "user_signed_up",
    properties = mapOf(
        "\\$groups" to mapOf(
            "company" to "company_id_in_your_db"
        )
    )
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-segment"
        }}>{`// You'll always need to pass through the $groups object for Segment, even for analytics.js
analytics.track('user_signed_up', {
    $groups: { segment_group: 'company_id_in_your_db' }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`# Call $groupidentify to create or update a group.
# It will also create the group type if it doesn't exist.
curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "event": "$groupidentify",
    "distinct_id": "static_string_used_for_all_group_events",
    "properties": {
        "$group_type": "company",
        "$group_key": "company_id_in_your_db"
    }
}' <ph_client_api_host>/i/v0/e/

# Once the group is created, you can associate events with it by
# passing the \`$groups\` property. The \`$groups\` property is required
# for every event that should be associated with the group.
curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "event": "user_signed_up",
    "distinct_id": "user_distinct_id",
    "properties": {
        "$groups": {"company": "company_id_in_your_db"}
    }
}' <ph_client_api_host>/i/v0/e/
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      